// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { put, takeEvery, select, all } from 'redux-saga/effects';

import { configureAppInsightsWithCV } from 'src/lib/ApplicationInsights';
import CorrelationVector from 'src/lib/CorrelationVector';

import { resetActionsData } from './../../../store/actionStatus';
import {
    CHECKOUT_ORDER,
    GET_PART_INFO,
    resetOrderData,
    resetPartsStatus,
} from './../../../store/orderCreation/actions';
import { resetOnStartOver, resetStoreOnSearch } from './../../../store/action';
import { resetDeviceData } from './../../../store/deviceInfo';
import { resetAddressData } from './../../../store/address';
import { replacePartsSelector } from './../../../store/orderCreation';
import { resetSelectedCountryData } from './../../../store/countries';
import {
    clearSafetyAttachmentInfo,
    CLEAR_SAFETY_ATTACHMENT_INFO,
} from './../../../store/attachments';

function* resetOnStartOverSaga(): IterableIterator<any> {
    yield put(resetDeviceData());
    yield put(resetActionsData());
    yield put(resetOrderData());
    yield put(resetPartsStatus());
    yield put(clearSafetyAttachmentInfo());
    yield put(resetActionsData(CLEAR_SAFETY_ATTACHMENT_INFO));
}

function* resetStoreOnSearchSaga(): IterableIterator<any> {
    CorrelationVector.resetCV();
    configureAppInsightsWithCV(CorrelationVector.getCurrentValue());

    yield put(resetDeviceData());
    yield put(resetActionsData());
    yield put(resetOrderData());
    yield put(resetAddressData());
    yield put(resetSelectedCountryData());
    yield put(clearSafetyAttachmentInfo());
    yield put(resetActionsData(CLEAR_SAFETY_ATTACHMENT_INFO));
}

function* resetPartsStatusSaga(): IterableIterator<any> {
    const parts = yield select((state) => replacePartsSelector(state));
    if (parts) {
        yield all(
            Object.keys(parts).map((part: string) => {
                return put(resetActionsData(`${GET_PART_INFO}-${part}`));
            })
        );
    }

    yield put(resetActionsData(CHECKOUT_ORDER));
}

export default [
    takeEvery(`${resetOnStartOver}`, resetOnStartOverSaga),
    takeEvery(`${resetStoreOnSearch}`, resetStoreOnSearchSaga),
    takeEvery(`${resetPartsStatus}`, resetPartsStatusSaga),
];
